import { SHOWLEADEVENT } from "../constants/event";
import { beginFacilityLead } from "./googleanalytics";

export function addContactButtonClick(btnid: string) {
    const button = document.getElementById(btnid);
    if (!button) {
        return;
    }
    button.onclick = function (event: MouseEvent) {
        event.preventDefault();
        const someEvent = new Event(SHOWLEADEVENT);
        window.dispatchEvent(someEvent);
        beginFacilityLead();
    };
}
